import { Component, OnInit, Input } from '@angular/core';
import * as c3 from "c3";

@Component({
  selector: 'app-line-graph',
  templateUrl: './line-graph.component.html',
  styleUrls: ['./line-graph.component.scss']
})
export class LineGraphComponent implements OnInit {

  constructor() { }

  @Input() data: any;
  @Input() data2: any;

  chart: any;

  ngOnInit(): void {
    if(this.data != null && this.data2 != null){
      this.chart = c3.generate({
        bindto: "#chart",
        data: {
          columns: [
            this.data,
            this.data2
          ]
        },
        axis: {
          x: {
            show: false,
            tick: {
              format: (x) => {
                return "Día " + x;
              }
            },
          },
          y: {
            show: false,
          }
        }
      });
    } else if(this.data != null){
      this.chart = c3.generate({
        bindto: "#chart",
        data: {
          columns: [
            this.data
          ],
        },
        legend: {
          show: false,
        },
        axis: {
          x: {
            show: false,
            tick: {
              format: (x) => {
                return this.data[1] + " " + x;
              }
            },
          },
          y: {
            show: false,
          }
        }
      });
    }
  }
}
